import { callGlobalFunction, readGlobal } from "./utils.js";

export const adminFeature = {
  get session() {
    return readGlobal("currentAdmin", null);
  },
  login() {
    return callGlobalFunction("performAdminLogin");
  },
  logout() {
    return callGlobalFunction("handleAdminLogout");
  },
  switchTab(tabName) {
    return callGlobalFunction("switchAdminTab", tabName);
  },
  refreshStats() {
    return callGlobalFunction("renderAdminStats");
  },
  refreshSubscriptions() {
    return callGlobalFunction("renderAdminSubscriptions");
  },
  refreshClients() {
    return callGlobalFunction("renderAdminClients");
  },
  refreshProviders() {
    return callGlobalFunction("renderAdminProviders");
  },
  refreshOrders() {
    return callGlobalFunction("renderAdminOrders");
  }
};
